<template>
  <span class="tools01-page-list-active-switch">
    <el-switch v-model="active"></el-switch>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ActiveSwitch",
  props: {
    pageId: String,
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rt", "apiErrorMessage"]),
    pageData() {
      return this.$store.getters["tools01/pageData"](this.pageId);
    },
    active: {
      get() {
        return this.pageData.active;
      },
      set(newValue) {
        let active = "0";
        if (newValue === true) {
          active = "1";
        }
        let params = new URLSearchParams();
        params.append("tool_id", this.pageData.toolId);
        params.append("site_id", this.pageData.siteId);
        params.append("active", active);
        this.$axios
          .post(`${this.rt}/l/api/tools01/page/update-active`, params)
          .then((response) => {
            console.log(response);
            //新方式は成功時に本文へ status を入れない。
            //CheckUserId だけ旧方式 (HTTP 200 + 本文 status:401) のため、本文に status があればセッション切れ
            if (response.data.status === undefined) {
              this.$store.dispatch("tools01/setPageList");
            } else {
              alert(response.data.message);
              this.$router.push("/login");
            }
          })
          .catch((error) => {
            console.log(error);
            //配信条件を満たしていない場合 (400) もここに来る
            alert(this.getErrorMessage(error));
            //スイッチの見た目を実際の状態に戻す
            this.$store.dispatch("tools01/setPageList");
          });
      },
    },
  },
  watch: {},
  methods: {
    getErrorMessage(error) {
      let message = this.apiErrorMessage;
      if (error.response && error.response.data && error.response.data.message) {
        message = error.response.data.message;
      }
      return message;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
